import React, { useContext, useEffect, useState } from "react";
import {
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { GraficoComboStyled } from "../../styles/meteorologia/containerComboGraficos";
import { ClimaContext } from "../../contexts/contexClima";
import { parseISO, format } from "date-fns";
import { apiConnect } from "../../services/api";

const diasDaSemana = [
  { nome: "Seg.", chave: "previsaoSegunda" },
  { nome: "Ter.", chave: "previsaoTerca" },
  { nome: "Qua.", chave: "previsaoQuarta" },
  { nome: "Qui.", chave: "previsaoQuinta" },
  { nome: "Sex.", chave: "previsaoSexta" },
  { nome: "Sáb.", chave: "previsaoSabado" },
  { nome: "Dom.", chave: "previsaoDomingo" },
];

export const GraficoPressaoAtmosferica = () => {
  const { climaIdSelect, calenderDate, listHistorico } =
    useContext(ClimaContext);

  const [listPrevisoesClima, setListPrevisoesClima] = useState(null);

  const obterIndiceDiaAtual = () => {
    const hoje = new Date(calenderDate).getDay(); // 0 (Dom) a 6 (Sáb)
    return hoje === 0 ? 6 : hoje - 1; // Ajusta para Segunda-feira como 0
  };

  const obterDiasValidos = () => {
    const indiceDiaAtual = obterIndiceDiaAtual();
    const diasValidos = [
      ...diasDaSemana.slice(indiceDiaAtual),
      ...diasDaSemana.slice(0, indiceDiaAtual),
    ].slice(0, 5);

    return diasValidos;
  };

  const listPrevisoes = async (idSelect) => {
    const token = sessionStorage.getItem("connectionsToken");

    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await apiConnect.get(
        `/meteorologia/previsao/Leitura/${idSelect}`,
        headerApi
      );
      setListPrevisoesClima(response.data);
    } catch (error) {
      console.log(error);
      setListPrevisoesClima([]);
    }
  };

  useEffect(() => {
    if (climaIdSelect != null) {
      listPrevisoes(climaIdSelect);
    }
  }, [climaIdSelect]);

  const diaAtualChave = obterDiasValidos()[0]?.chave;

  const previsaoDoDia =
    listPrevisoesClima && diaAtualChave
      ? listPrevisoesClima[diaAtualChave]
      : [];

  // Prepare os dados para o gráfico
  const data = previsaoDoDia
    .sort((a, b) => {
      // Transformar forecast_data em números para comparação
      const [aHours, aMinutes] = a.forecast_data.split(":").map(Number);
      const [bHours, bMinutes] = b.forecast_data.split(":").map(Number);

      // Comparar as horas e minutos
      return aHours !== bHours ? aHours - bHours : aMinutes - bMinutes;
    })
    .map((item) => {
      // const time = format(parseISO(item.changedAt), "HH:mm");
      const historicoPresao = listHistorico.find((e) => {
        const horarioHistorico = format(parseISO(e.changedAt), "HH:mm");
        const horarioItem = item.forecast_data;

        return horarioHistorico == horarioItem;
      });

      return {
        time: item.forecast_data,
        currentPressure: historicoPresao?.pressure,
        forecastPressure: item.pressure,
      };
    });

  return (
    <GraficoComboStyled>
      <ResponsiveContainer>
        <ComposedChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <CartesianGrid />
          <XAxis dataKey="time" tick={{ fontSize: 11, color: "#ffffff" }} />
          <YAxis
            className="y"
            domain={["auto", "auto"]}
            tick={{ fontSize: 12 }}
            label={{
              value: "Pressão (hPa)",
              angle: -90,
              position: "insideBottomLeft",
            }}
          />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="currentPressure"
            stroke="#ff7300"
            strokeWidth={3}
            name="Pressão Atual"
          />
          <Line
            type="monotone"
            dataKey="forecastPressure"
            stroke="#55be0a"
            strokeWidth={3}
            name="Previsão de Pressão"
            strokeDasharray="5 3"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </GraficoComboStyled>
  );
};
